// extracted by mini-css-extract-plugin
export var blink = "_77-2";
export var cursor = "_77-1";
export var reactMarkdown = "_77-3";
export var streamingText = "_77-0";